import { FeatureTypes } from "entity-app/constants";
import { useMemo } from "react";
import MaterialBulkInstruction from "./material-bulk-instruction";
import MaterialInstruction from "./material-instructions";
import SubmittalInstruction from "./submittal-instructions";
import SubmittalBulkInstruction from "./submittal-bulk-instructions";

export default function LinkingInstructions({
  featureTypeId,
  isBulk = false
}: {
  featureTypeId: FeatureTypes;
  isBulk?: boolean;
}) {
  const instructions = useMemo(() => {
    switch (featureTypeId) {
      case FeatureTypes.MATERIALS:
        if (isBulk) return <MaterialBulkInstruction />;
        return <MaterialInstruction />;
      case FeatureTypes.SUBMITTALS:
        if (isBulk) return <SubmittalBulkInstruction />;
        return <SubmittalInstruction />;
      default:
        return null;
    }
  }, [featureTypeId, isBulk]);
  return instructions;
}
